
// SVG Icon: download-new
export default { id: "terriajs-download-new" };
export const id = "terriajs-download-new";
export const name = "download-new";
